<template>
  <p class="clearfix mb-0">
    <span class="float-md-left d-block d-md-inline-block mt-25">
      CoolMon  © {{ new Date().getFullYear() }}
      <b-link
        class="ml-25"
        href="https://joule.work"
        target="_blank"
      >Joule.work</b-link>
      <span class="d-none d-sm-inline-block" />
    </span>

    <span class="float-md-right d-none d-md-block">Precisa de ajuda
      <feather-icon
        icon="HelpCircleIcon"
        size="21"
        class="text-danger stroke-current"
      />
    </span>
  </p>
</template>

<script>
import { BLink } from 'bootstrap-vue'

export default {
  components: {
    BLink,
  },
}
</script>
